import { BiSolidPackage } from "react-icons/bi";
import { PiHouseFill } from "react-icons/pi";

export const dedicatedOrderStatuses = {
  unSubmitted: "unSubmitted",
  submitted: "submitted",
  completed: "completed",
  missed: "missed",
};

export const collapsedStates = {
  map: {
    value: "map",
    icon: (
      <div
        style={{
          display: "flex",
          gap: "1px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "gray",
            width: "1px",
            height: "15px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "1px",
            height: "15px",
          }}
        ></div>{" "}
        <div
          style={{
            backgroundColor: "gray",
            width: "4px",
            height: "17px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "9px",
            height: "17px",
          }}
        ></div>
      </div>
    ),
  },
  full: {
    value: "full",
    icon: (
      <div
        style={{
          display: "flex",
          gap: "1px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "gray",
            width: "4px",
            height: "15px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "4px",
            height: "15px",
          }}
        ></div>{" "}
        <div
          style={{
            backgroundColor: "gray",
            width: "4px",
            height: "15px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "5px",
            height: "15px",
          }}
        ></div>
      </div>
    ),
  },
  lists: {
    value: "lists",
    icon: (
      <div
        style={{
          display: "flex",
          gap: "1px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "gray",
            width: "5px",
            height: "17px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "5px",
            height: "17px",
          }}
        ></div>{" "}
        <div
          style={{
            backgroundColor: "gray",
            width: "1px",
            height: "15px",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "gray",
            width: "1px",
            height: "15px",
          }}
        ></div>
      </div>
    ),
  },
};

export const collapsedStatePanelSizes = {
  orders: {
    map: 1.5,
    full: 1,
    lists: 6,
  },
  positions: {
    map: 1.5,
    full: 1,
    lists: 6,
  },
  stops: {
    map: 4.7,
    full: 1,
    lists: 1.3,
  },
  map: {
    map: 20,
    full: 3,
    lists: 1,
  },
};

export const dispatchErrorMessages = {
  driverDeparted: "It seems the driver has already departed.",
};

export const CXTStopTypes = {
  delivery: {
    display: "Delivery",
    value: 1,
  },
  pickup: {
    display: "Pickup",
    value: 0,
  },
};

//FIRST, check to see if the order you are passing doesn't already have a status field that was generated previously.
export const determineDedicatedOrderStatus = (order) => {
  return order.completedTime
    ? dedicatedOrderStatuses.completed
    : order.positionId
    ? dedicatedOrderStatuses.submitted
    : dedicatedOrderStatuses.unSubmitted;
};

export const glyphTypes = {
  home: { type: "home", glyph: <PiHouseFill /> },
  package: { type: "package", glyph: <BiSolidPackage /> },
};
